import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../components/Buttons";

export const Login = () => {
    document.title = "Daxil ol";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Daxil ol", value: "/cash/login", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Kassa proqramı</h2>
                    <p>
                        İnternet olmadan kassa proqramına daxil olmaq üçün <Button>Şəbəkəsiz</Button> seçimini edin. Bu halda kassadan icra olunan əməliyyatlar
                        yadda saxlanılır və şəbəkəyə qoşulduqda məlumatlar sinxronizasiya olunur. İnternet olduğu halda kassa proqramına daxil olmaq üçün{" "}
                        <SaveButton>Daxil ol</SaveButton> seçimini etmək lazımdır.
                    </p>
                    <img src="/images/cash/login.gif" alt="Daxil ol" />
                </article>
            </div>
        </div>
    );
};
